// @ts-ignore
/* eslint-disable */
import { request } from '@umijs/max';
const baseUrl = 'http://118.123.240.248:8888/api/v1/';
// const baseUrl = '/api/';
/** 获取当前的用户 GET /api/currentUser */
export async function currentUser(options?: { [key: string]: any }) {
  return request<{
    statusCode: number;
    data: API.CurrentUser;
  }>(baseUrl + 'currentUser', {
    method: 'GET',
    ...(options || {}),
  });
}

/** 退出登录接口 POST /api/login/outLogin */
export async function outLogin(options?: { [key: string]: any }) {
  return request<Record<string, any>>(baseUrl + 'login/outLogin', {
    method: 'POST',
    ...(options || {}),
  });
}

/** 登录接口 POST /api/login/account */
export async function login(body: API.LoginParams, options?: { [key: string]: any }) {
  return request<API.RequestResult>(baseUrl + 'login/account', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** 注册接口 POST /api/register */
export async function register(body: API.LoginParams, options?: { [key: string]: any }) {
  return request<API.RequestResult>(baseUrl + 'register', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** 获取验证码接口 POST /api/register */
export async function getCode(body: API.GetCodeParams, options?: { [key: string]: any }) {
  return request<API.RequestResult>(baseUrl + 'send_code', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** 此处后端没有提供注释 GET /api/notices */
export async function getNotices(options?: { [key: string]: any }) {
  return request<API.NoticeIconList>(baseUrl + 'notices', {
    method: 'GET',
    ...(options || {}),
  });
}

/** 获取规则列表 GET /api/rule */
export async function rule(
  params: {
    // query
    /** 当前的页码 */
    current?: number;
    /** 页面的容量 */
    pageSize?: number;
  },
  options?: { [key: string]: any },
) {
  return request<API.RuleList>(baseUrl + 'rule', {
    method: 'GET',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 更新规则 PUT /api/rule */
export async function updateRule(options?: { [key: string]: any }) {
  return request<API.RuleListItem>(baseUrl + 'rule', {
    method: 'POST',
    data: {
      method: 'update',
      ...(options || {}),
    },
  });
}

/** 新建规则 POST /api/rule */
export async function addRule(options?: { [key: string]: any }) {
  return request<API.RuleListItem>(baseUrl + 'rule', {
    method: 'POST',
    data: {
      method: 'post',
      ...(options || {}),
    },
  });
}

/** 删除规则 DELETE /api/rule */
export async function removeRule(options?: { [key: string]: any }) {
  return request<Record<string, any>>(baseUrl + 'rule', {
    method: 'POST',
    data: {
      method: 'delete',
      ...(options || {}),
    },
  });
}

/** 获取图谱列表 GET /api/atlas */
export async function getAtlas(options?: { [key: string]: any }) {
  return request<API.RequestResult>(baseUrl + 'atlas', {
    method: 'GET',
    ...(options || {}),
  });
}

/** 获取结构列表 GET /api/structures */
export async function getStructures(atlaId: number) {
  return request<API.RequestResult>(baseUrl + 'structures', {
    method: 'GET',
    params: {
      atlaId,
    },
  });
}

//* 获取患者列表
export async function getPatients(options?: { [key: string]: any }) {
  return request<API.RequestResult>(baseUrl + 'patients', {
    method: 'GET',
    ...(options || {}),
  });
}

/** 获取结构数据 POST /api/structure_data */
export async function getStructureData(structureId: number, dataType: string, sex: string, brainSide: string, atla: string) {
  return request<API.RequestResult>(baseUrl + 'structure_data', {
    method: 'POST',
    data: {
      structureId,
      dataType,
      sex,
      brainSide,
      atla
    },
  });
}

/** 获取患者数据 POST /api/patient_data */
export async function getPatientData(patientId: number, structureId: number, hemisphere: string) {
  console.log(patientId, structureId);
  return request<API.RequestResult>(baseUrl + 'patient_data', {
    method: 'POST',
    data: {
      patientId,
      structureId,
      hemisphere,
    },
  });
}

/** 获取用户列表 GET /api/user */
export async function getUserList(options?: { [key: string]: any }) {
  return request<API.RequestResult>(baseUrl + 'user_list', {
    method: 'POST',
    data: options
  });
}

/** 获取机构样本数据 POST /api/patient_list */
export async function getPatientList(options?: { [key: string]: any }) {
  return request<API.RequestResult>(baseUrl + 'patient_list', {
    method: 'POST',
    data: options
  });
}

/** 下载文件 POST /api/download_file */
export async function downloadFile(options?: { [key: string]: any }) {
  return request<API.RequestResult>(baseUrl + 'download_data', {
    method: 'POST',
    data: options
  });
}

/** 启用/禁用用户 POST /api/user_status */
export async function userStatus(options?: { [key: string]: any }) {
  return request<API.RequestResult>(baseUrl + 'update_user', {
    method: 'POST',
    data: options
  });
}

/** 删除患者 POST /api/delete_patient */
export async function deletePatient(options?: { [key: string]: any }) {
  return request<API.RequestResult>(baseUrl + 'delete_patient', {
    method: 'POST',
    data: options
  });
}

/** 删除用户 POST /api/delete_user */
export async function userDelete(options?: { [key: string]: any }) {
  return request<API.RequestResult>(baseUrl + 'delete_user', {
    method: 'POST',
    data: options
  });
}

/** 添加用户 POST /api/add_user */
export async function addUser(body: API.LoginParams, options?: { [key: string]: any }) {
  return request<API.RequestResult>(baseUrl + 'register', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}